import { Icon } from '@codeparva/ui-components-library';
import React from 'react';
import { FontAwesomeIcon } from '../../../../../utilities/iconLoader/FontAwesomeIcon';
import { FooterTypes } from '../footerTypes';
import { useThemeContext } from '../hooks/themeContext';
import { getSocialIconsColor, getTextColor } from './ColorSelectorHelper';

export const FacilityAddressReachUs = ({
  reachUsDetails,
  address,
}: FooterTypes.TReachUsDataAddress) => {
  const { iconsConfig } = reachUsDetails;
  const { facilityAddress, googleMapsUrl } = address;
  const currTheme = useThemeContext();
  const socialIconsColor = getSocialIconsColor(currTheme);
  return (
    <li className="address">
      <Icon size="medium" className={'locationIcon'}>
        <FontAwesomeIcon
          iconClassName={iconsConfig.facilityAddressIcon}
          iconContextProps={{
            className: socialIconsColor,
            style: {
              fontSize: 20,
            },
          }}
        />
      </Icon>
      &nbsp;
      <a
        href={googleMapsUrl}
        rel="noreferrer"
        target="_blank"
        className={`has-text-${getTextColor(currTheme)} has-text-weight-bold`}
      >
        {facilityAddress}
      </a>
    </li>
  );
};
export const EmailAddressReachUs = ({
  reachUsDetails,
  mail,
}: FooterTypes.TReachUsDataEmailAddress) => {
  const { iconsConfig } = reachUsDetails;
  const emailIDRedirect = (mail: string) => {
    return `mailto:${mail},${reachUsDetails}`;
  };
  const currTheme = useThemeContext();
  const socialIconsColor = getSocialIconsColor(currTheme);

  return (
    <li className="email">
      <Icon size="medium" className="emailIcon">
        <FontAwesomeIcon
          iconClassName={iconsConfig.emailIDIcon}
          iconContextProps={{
            className: socialIconsColor,
            style: {
              fontSize: 20,
            },
          }}
        />
      </Icon>
      &nbsp;
      <a
        href={emailIDRedirect(mail)}
        rel="noreferrer"
        className={`has-text-${getTextColor(currTheme)} has-text-weight-bold`}
      >
        {mail}
      </a>
    </li>
  );
};

export const ContactNumberReachUs = ({
  reachUsDetails,
  phoneno,
}: FooterTypes.TReachUsDataPhoneNumber) => {
  const currTheme = useThemeContext();
  const socialIconsColor = getSocialIconsColor(currTheme);
  const { iconsConfig } = reachUsDetails;
  const phoneNumberRedirect = (phoneNumber: string) => {
    return `tel:${phoneNumber.replace(/[^a-zA-Z0-9]/g, '')}`;
  };
  return (
    <li className="phone">
      <Icon size="medium" className="phoneIcon">
        <FontAwesomeIcon
          iconClassName={iconsConfig.phoneNumberIcon}
          iconContextProps={{
            className: socialIconsColor,
            style: {
              fontSize: 20,
            },
          }}
        />
      </Icon>
      &nbsp;
      <a
        href={phoneNumberRedirect(phoneno)}
        rel="noreferrer"
        className={`has-text-${getTextColor(currTheme)} has-text-weight-bold`}
      >
        {phoneno}
      </a>
    </li>
  );
};
